import {createNamespacedHelpers} from 'vuex'
import DefaultTmpl from '@/templates/DefaultTmpl'


export default {
    mount(base_name) {
        const {mapActions} = createNamespacedHelpers(base_name);
        return {
            components: {
              DefaultTmpl
            },
            data() {
                return {
                    entity: {},
                    errors: {}
                }
            },
            methods: {
                afterReset() {},
                reset() {
                    this.createEntity();
                    this.errors = {};
                    this.$router.push(`/${base_name}/new`);
                    this.afterReset();
                },
                createEntity() {
                    this.entity = {}
                },
                submit() {
                    if (this.beforeSubmit) this.beforeSubmit();

                    this.save(this.entity)
                        .then(data => {
                            this.errors = {};
                            this.$snotify.success(this.$t('common.dataSaveSuccess'), this.$appStorage.getUser().name);
                            if(!this.entity.id) this.$router.push({path: `/${base_name}/${data.id}/edit`})
                            else this.onLoadSuccess(data)
                        })
                        .catch(({response}) => {
                            this.$appUtils.vibrate();

                            if (response.status === 422) {
                                Object.keys(response.data).forEach(k => {
                                    this.$set(this.errors, k, response.data[k]);
                                });
                                this.$snotify.warning('Verifique os dados informados', 'Validação');
                            } else if (response.status === 403) {
                                this.$snotify.error('Você não possui permissão para executar essa ação', 'Permissão')
                            } else {
                                this.$snotify.error(this.$t('commons.tryContactSupport', {msg: 'Ops... Aconteceu algum problema inesperado.'}), this.$appStorage.getUser().name);
                            }
                        });
                },
                onLoadSuccess(entity) {
                    this.entity = entity;
                },
                loadEntity(id) {
                    this.load(id)
                        .then(this.onLoadSuccess)
                        .catch(err => {
                            console.error('Fail to load entity.', err);
                            this.$appUtils.vibrate(200);
                            this.$snotify.error(this.$t('commons.tryContactSupport', {msg: 'Ops... Aconteceu algum problema inesperado ao tentar carregar o item.'}), this.$appStorage.getUser().name);
                        })
                },
                onAfterRouteEnter(){},
                onAfterRouteUpdate(){},
                ...mapActions(['save', 'load'])
            },
            created() {
                this.createEntity();
            },
            beforeRouteEnter (to, from, next) {
                if (to.params.id) {
                    next(vm => {
                        vm.loadEntity(to.params.id);
                        vm.onAfterRouteEnter();
                    });
                } else next(vm => {
                    vm.createEntity();
                    vm.errors = {};
                    vm.onAfterRouteEnter();
                })
            },
            beforeRouteUpdate(to, from, next) {
                if (to.params.id) this.loadEntity(to.params.id);
                else {
                    this.createEntity();
                    this.errors = {}
                }
                this.onAfterRouteUpdate();
                next();
            }
        }
    }
};
